import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { getPostAndMorePosts } from '../../services/CMSBlogService'
import { BlogPost } from '../../pages/[locale]/blog/[slug]/index.page'
import { stripHtml } from '../../utils/stripHtml'
import styled from 'styled-components'
import { StaticI18nLink } from '../Link'

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
`

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
`

export default function BlogPreviewPage() {
  const [postData, setPostData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  
  const router = useRouter()
  const { slug } = router.query

  useEffect(() => {
    getPostAndMorePosts(slug).then(data => {
      if (!data) {
        setError('Post não encontrado')
        setIsLoading(false)
        return
      }

      setPostData(data)
      setIsLoading(false)
    }).catch(error => {
      setError(error)
      setIsLoading(false)
    })
  }, [slug])

  if (isLoading) return <LoadingContainer>Carregando... <StaticI18nLink href="/blog">Voltar para a lista de posts</StaticI18nLink></LoadingContainer>
  if (error) return <ErrorContainer>
    Erro ao carregar o post <StaticI18nLink href="/blog">Voltar para a lista de posts</StaticI18nLink>
  </ErrorContainer>

  return <BlogPost
    preview
    post={postData?.post}
    morePosts={postData?.morePosts}
    mainContentWithoutHtml={stripHtml(postData?.post?.metadata?.meta_description)}
  />
}
